import React from 'react';

import Button from '../../../Button/assets';
import {
  Body,
  Container,
  Footer,
  Header,
} from '../../../Modal/assets/scripts/Parts';

import { MODAL_ID } from './constants';
import { ConfirmProps } from './types';

const handleConfirm = (props: ConfirmProps) => (): void => {
  props.setConfirmed();
  props.hideModal();
};

const renderButtons = (props: ConfirmProps): JSX.Element => (
  <>
    <Button
      label={props.cancelLabel}
      negative={props.noDelete}
      onClick={props.hideModal}
      secondary
    />
    <Button
      label={props.confirmLabel}
      negative={!props.noDelete}
      onClick={handleConfirm(props)}
      secondary
    />
  </>
);

const Confirm = (props: ConfirmProps): JSX.Element => (
  <div
    className="modal fade"
    id={MODAL_ID}
    aria-hidden="false"
    aria-labelledby={MODAL_ID}
    role="dialog"
    tabIndex={-1}
  >
    <Container narrow={!props.text}>
      <Header onClose={props.hideModal} title={props.title} />
      <Body>
        {props.text ? (
          <p className="modal-body__confirm">{props.text}</p>
        ) : (
          <p className="modal-body__confirm modal-body__confirm--simple modal-body__confirm--reverse">
            {renderButtons(props)}
          </p>
        )}
      </Body>
      {props.text && <Footer>{renderButtons(props)}</Footer>}
    </Container>
  </div>
);

export default Confirm;
